import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { estimateSelector } from '../../../redux'
import ValueRangeChart from './ValueRangeChart'
import PriceSourcesLegend from './PriceSourcesLegend'

export const EstimationContent = () => {
  const estimate = useSelector(estimateSelector)

  return (
    <Box>
      <Box sx={{ height: '200px', width: '100%' }}>
        <ValueRangeChart
          data={estimate?.graphData ?? []}
          price={estimate?.price ?? 0}
          lowerPrice={estimate?.lowRange ?? 0}
          upperPrice={estimate?.upperRange ?? 0}
        />
      </Box>
      <PriceSourcesLegend sources={estimate?.graphData ?? []} />
    </Box>
  )
}

export default EstimationContent
